/** RIS access strings. Login/session payload is `{code}.Full`. */
export const ADMIN_ACCESS = {
  patientAdmin: 'Portal.Patient.Admin',
  trainingMaterial: 'Portal.Patient.Admin.TrainingMaterial',
  cacheInfo: 'Portal.Patient.Admin.CacheInfo',
  configAccess: 'Portal.Patient.Admin.ConfigAccess',
  userMgt: 'Portal.Patient.Admin.UserMgt',
  userMsgs: 'Portal.Patient.Admin.UserMsgs',
  sysMsgs: 'Portal.Patient.Admin.SysMsgs',
  workflowFailures: 'Portal.Patient.Admin.WorkflowFailures',
  audit: 'Portal.Patient.Admin.Audit',
  systemHealth: 'Portal.Patient.Admin.SystemHealth',
  errorLogs: 'Portal.Patient.Admin.ErrorLogs',
  lookupHistory: 'Portal.Patient.Admin.LookupHistory',
  remoteAccess: 'Portal.Patient.Admin.RemoteAccess',
} as const;

export type AdminAccessString = (typeof ADMIN_ACCESS)[keyof typeof ADMIN_ACCESS];
